"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleLink = exports.RelatedArticlesPanelLink = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var _palette = require("@artsy/palette");

var _Analytics = require("../../../../Artsy/Analytics");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _resizer = require("../../../../Utils/resizer");

var _Constants = require("../../Constants");

var _dec, _class, _class2, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RelatedArticlesPanelLink = (_dec = (0, _Analytics.track)(), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RelatedArticlesPanelLink, _React$Component);

  function RelatedArticlesPanelLink() {
    _classCallCheck(this, RelatedArticlesPanelLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(RelatedArticlesPanelLink).apply(this, arguments));
  }

  _createClass(RelatedArticlesPanelLink, [{
    key: "render",
    value: function render() {
      var article = this.props.article;
      var href = (0, _Constants.getEditorialHref)(article.layout, article.slug);
      var articleImageSrc = (0, _resizer.crop)(article.thumbnail_image, {
        width: 160,
        height: 110
      });
      return _react.default.createElement(ArticleLink, {
        href: href
      }, _react.default.createElement(ArticleImage, {
        src: articleImageSrc
      }), _react.default.createElement(_palette.Serif, {
        size: "4t",
        color: (0, _palette.color)("black100")
      }, article.thumbnail_title));
    }
  }]);

  return RelatedArticlesPanelLink;
}(_react.default.Component), _defineProperty(_class2, "defaultProps", {
  label: "Related Stories"
}), _temp)) || _class);
exports.RelatedArticlesPanelLink = RelatedArticlesPanelLink;

var ArticleLink = _styledComponents.default.a.withConfig({
  displayName: "RelatedArticlesPanelLink__ArticleLink",
  componentId: "sc-1gcgwm7-0"
})(["text-decoration:none;display:flex;justify-content:left;margin-bottom:", "px;"], (0, _palette.space)(2));

exports.ArticleLink = ArticleLink;

var ArticleImage = _styledComponents.default.img.withConfig({
  displayName: "RelatedArticlesPanelLink__ArticleImage",
  componentId: "sc-1gcgwm7-1"
})(["min-width:80px;height:55px;margin-right:", "px;"], (0, _palette.space)(1));
//# sourceMappingURL=RelatedArticlesPanelLink.js.map